import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class ScreeningPackage extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  sterlingPackageIdentifier: string;

  @autoserialize
  driverSuspendOnFail: boolean;

  @autoserialize
  active: boolean;

  @autoserializeAs(Date)
  requiredByDate: Date;

  static OnSerialized(instance: ScreeningPackage, json: any): void {
    if (!isNullOrUndefined(instance.requiredByDate)) {
      json.requiredByDate = DateUtil.serializeLocalDate(instance.requiredByDate);
    }
  }

  static OnDeserialized(instance: ScreeningPackage, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['requiredByDate'])) {
      instance.requiredByDate = DateUtil.deserializeLocalDate(json['requiredByDate']);
    }
  }
}
